import { RedirectToPageNotFound } from '../page-not-found/PageNotFound';
import { GenericErrorPage } from './GenericErrorPage';

export type ErrorPageProps = {
  error: Error | null;
};

// For displaying an error as the entire page.
export const ErrorPage = ({error} : ErrorPageProps) => {
  if (error === null) {
    return (<GenericErrorPage/>)
  }
  switch (error?.cause){
    case 400:
    case 401:
    case 403:
    case 404:
      return RedirectToPageNotFound();   
    default: 
      return (<GenericErrorPage/>)
  }
};

export default ErrorPage;